var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4825 9.62405L18.2124 2.8938C18.3976 2.70854 18.4997 2.46137 18.5 2.1978C18.5 1.9341 18.3979 1.68663 18.2124 1.50166L17.6227 0.912048C17.4373 0.726341 17.1901 0.624634 16.9262 0.624634C16.6628 0.624634 16.4157 0.726341 16.2302 0.912048L9.50029 7.64185L2.77005 0.912048C2.58493 0.726341 2.33761 0.624634 2.0739 0.624634C1.81049 0.624634 1.56317 0.726341 1.37805 0.912048L0.788 1.50166C0.404 1.88566 0.404 2.51024 0.788 2.8938L7.5181 9.62405L0.788 16.354C0.602732 16.5396 0.500732 16.7867 0.500732 17.0503C0.500732 17.3139 0.602732 17.561 0.788 17.7464L1.3779 18.336C1.56302 18.5216 1.81049 18.6235 2.07376 18.6235C2.33746 18.6235 2.58478 18.5216 2.7699 18.336L9.50015 11.6061L16.2301 18.336C16.4155 18.5216 16.6627 18.6235 16.9261 18.6235H16.9264C17.19 18.6235 17.4371 18.5216 17.6225 18.336L18.2123 17.7464C18.3974 17.5612 18.4996 17.3139 18.4996 17.0503C18.4996 16.7867 18.3974 16.5396 18.2123 16.3541L11.4825 9.62405Z",
    fill: "#ffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCloseWhite);
export default __webpack_public_path__ + "static/media/nav_close_white.ba10136609371e7b7f6d6e9c93eb5f34.svg";
export { ForwardRef as ReactComponent };